import { render, staticRenderFns } from "./NoConnectionModal.vue?vue&type=template&id=2165d38c"
import script from "./NoConnectionModal.vue?vue&type=script&lang=ts"
export * from "./NoConnectionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2165d38c')) {
      api.createRecord('2165d38c', component.options)
    } else {
      api.reload('2165d38c', component.options)
    }
    module.hot.accept("./NoConnectionModal.vue?vue&type=template&id=2165d38c", function () {
      api.rerender('2165d38c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NoConnectionModal.vue"
export default component.exports